module.exports = __webpack_public_path__ + "media/old_images/place-main-generic@2x-9eefc81c.png";